import React from "react";
import { BarChart3Icon, ClipboardCheckIcon, FilterIcon, FolderOpenIcon, GitBranchIcon, LayoutGridIcon, MapIcon, SplitIcon, BoxIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { SectionHeading } from "./SectionHeading";
import { toolkit } from "../data/toolkit";
const ICONS: Record<string, BoxIcon> = {
  tree: GitBranchIcon,
  checklist: ClipboardCheckIcon,
  filter: FilterIcon,
  grid: LayoutGridIcon,
  split: SplitIcon,
  map: MapIcon,
  chart: BarChart3Icon,
  folder: FolderOpenIcon
};
export function Toolkit() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-314" data-mp="5yprotj9tbsg">
      <SectionHeading tone="dark" eyebrow="Also included: The Complete Sensory Modulation Decision Toolkit™" title="More Than 30 Practical Tools to Help You Organize Your Reasoning" data-id="element-315" data-mp="ksupdjsqj27r" />
      <p className="mx-auto mt-5 max-w-2xl text-center text-[17px] leading-relaxed text-white/75" data-id="element-316" data-mp="2mkh7evunfms3">
        Alongside the six volumes, you’ll receive a collection of practical resources designed to help you put the framework into use.
      </p>

      <ul className="mx-auto mt-10 grid max-w-5xl grid-cols-1 gap-x-8 gap-y-2 md:grid-cols-2" data-id="element-317" data-mp="2021ty3ov85qm">
        {toolkit.map(t => {
        const Icon = ICONS[t.icon];
        return <li key={t.title} className="flex items-start gap-4 border-b border-white/10 py-5" data-id="element-318" data-mp="28zuafb6bpjfl">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-white/10 text-[#C9B8F5]" data-id="element-319" data-mp="2dsnf5z1skrro">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-320" data-mp="2ipx4lep6l3fi" />
              </span>
              <div data-id="element-321" data-mp="2noqhb4wn8qem">
                <h3 className="text-[17px] font-bold leading-snug text-white" data-id="element-322" data-mp="2no8cvkztv5vm">{t.title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-white/70" data-id="element-323" data-mp="2rsodp7ul3n3z">{t.text}</p>
              </div>
            </li>;
      })}
      </ul>

      <p className="mx-auto mt-10 max-w-2xl text-center text-[17px] leading-relaxed text-white/85 sm:text-lg" data-id="element-324" data-mp="xddhy13x3xyu">
        Imagine having a structured reference you can return to whenever a sensory modulation case feels difficult to organize. Instead of
        wondering where to begin, you’ll have a practical framework to help you identify{' '}
        <strong className="text-white" data-id="element-325" data-mp="20pb0x0rmmyv0">what you know, what you don’t know, and what you may need to investigate next.</strong>
      </p>

      <CTAButton className="mt-10" tone="dark" label="Get the complete Decision Toolkit™" data-id="element-326" data-mp="2ely25fqm4b6q" />
    </section>;
}